<script setup lang="ts">
/**
 * ✅TODO: Add multi-step component
 * ✅TODO: Create first part
 * ✅TODO: Create second part
 * ✅TODO: Create third part
 * TODO: Clean form after register
 * ⚠️TODO: Phone code input select with country flags
 * ✅TODO: Validation rules for first part
 * ✅TODO: Fill Address inputs automatic when the user fill the CEP input
 * TODO: Show password errors
 * ✅TODO: Validate form on final step
 * ✅TODO: Go to the step that contains an error after the user sends the complete register info
 * TODO: Terms modal
 * TODO: Validate multistep with captcha
 * ✅TODO: Step back button
 * ✅TODO: Disable next step until user complete all required fields
 * TODO: If user close the register modal bring it back on the last step that users has filled and not do any requests
 * ✅TODO: Redirect user to login if account already exists
 * ✅TODO: Create password validation with minimum of 6 characters and minium of 1 numeric character
 * TODO: Handle fetchError when the user document validation fails
 * ✅TODO: Pull Dudu's input error branch and change all errors on inputs to v$FormValidation.document.$errors.map((error) => error.$message)
 * ✅TODO: Put UF input as a select
 * ✅TODO: Clean errors when the user start typing on a input with a error that became from API
 * ✅TODO: Disable next button until user complete all inputs
 * TODO: Bring phone code contry input to here
 * ✅TODO: Show name input only after CPF was validated
 * TODO: Validate CPF with Vuelidate only after user have inputed all digits
 * TODO: Validate captcha before let the user send a request to our `document` API
 *
 * KYC
 * TODO: Identity verification modal after register complete
 * TODO: Require identify verification if user try to make an deposit
 * TODO: Require identify verification if user try to play a game
 * TODO: Require identify verification if user try to withdraw
 * TODO: Require identify verification if user try to place a bet on sports
 */
import { useAuthStore } from "@stores/auth";
import { useAlert } from "@stores/alert";
import { useVuelidate } from "@vuelidate/core";
import { required, email, helpers, sameAs, minLength } from "@vuelidate/validators";
import { cpfRule } from "@/validators/cpfRule";
import { consola } from "consola";
import { phoneRule } from "@validators/phoneRule";
import AuthRegisterCaptcha from "@components/auth/AuthRegisterCaptcha.vue";
import RulesModal from "@/components/password/RulesModal.vue";

const authStore = useAuthStore();
const { showAlert } = useAlert();

const state = reactive({
  form: {
    isLoading: false,
    document: {
      isLoading: false,
      isValid: false
    }
  }
});

const captchaToken = ref<string>('');
const showPasswordRules = ref(false);

watch(() => authStore.form.register.password, (newValue) => {
  if (newValue && v$FormValidation.value.password) {
    v$FormValidation.value.password.$touch(); 
  }
});

const handlePasswordFocus = () => {
  showPasswordRules.value = true;
  if (v$FormValidation.value.password) {
    v$FormValidation.value.password.$touch(); 
  }
};

const handlePasswordBlur = () => {
  showPasswordRules.value = false;
};

const handlePasswordRulesClose = () => {
  showPasswordRules.value = false;
};

const v$FormValidationExternalResults = ref();
const v$FormValidation = useVuelidate(computed(() => ({
  document: {
    required: helpers.withMessage("Campo obrigatório", required),
    cpf: helpers.withMessage("CPF inválido", cpfRule)
  },
  email: {
    required: helpers.withMessage("Campo obrigatório", required),
    email: helpers.withMessage("Informe um e-mail válido", email)
  },
  phone: {
    required: helpers.withMessage("Campo obrigatório", required),
    isValidPhoneNumber: helpers.withMessage("Telefone inválido", (value: string) => phoneRule(`+55${value}`))
  },
  password: {
    required: helpers.withMessage("Campo obrigatório", required),
    minimumNumberOfCharacters: helpers.withMessage("A senha deve ter no mínimo 8 caracteres", minLength(8)),
    hasNumeric: helpers.withMessage("A senha deve conter ao menos um dígito numérico", (value: string) => /\d/.test(value)),
    hasLetter: helpers.withMessage("A senha deve conter ao menos uma letra", (value: string) => /[a-zA-Z]/.test(value)),
    hasSpecialCharacter: helpers.withMessage("A senha deve conter ao menos um caractere especial", (value: string) => /[!@#$%^&*(),.?":{}|<>]/.test(value))
},
  termsAccepted: {
    required: helpers.withMessage("Você deve ler e aceitar os nossos termos e condições.", sameAs(true))
  }
})), authStore.form.register, { $externalResults: v$FormValidationExternalResults });

const submit = async () => {

  const isFormValid = await v$FormValidation.value.$validate();

  if (!v$FormValidation.value.$error && isFormValid) {
    try {
      state.form.isLoading = true;
      consola.warn(authStore.form.register);
      await authStore.register(captchaToken.value);
      showAlert("success", "Registro feito com sucesso!");
    } catch (err: any) {
      if (err.status === 422) {
        authStore.formErrors.register = err.data.errors;
        showAlert("error", err.data.message);
      } else {
        showAlert("error", err.message);
      }
    } finally {
      state.form.isLoading = false;
    }
  }
};

const handleUserDocumentValidation = async (value: string) => {
  if (value.length < 1) {
    resetDocumentValidationState();
    return;
  }

  state.form.document.isValid = false;
  authStore.form.register.name = "";

  const validationResult = await v$FormValidation.value.document.$validate();

  if (validationResult) {
    state.form.isLoading = true;
    state.form.document.isLoading = true;

    try {
      await authStore.validateDocument();
      state.form.document.isValid = true;
    } catch (err: any) {
      resetDocumentValidationState();
      showAlert("error", err.message);
    } finally {
      state.form.document.isLoading = false;
      state.form.isLoading = false;
    }
  }
};

const removeUserDocument = () => {
  authStore.form.register.document = "";
  authStore.form.register.name = "";
  authStore.form.register.birthday = "";


  if (v$FormValidation.value.document) {
    v$FormValidation.value.document.$reset();
  }

  if (v$FormValidationExternalResults.value) {
    v$FormValidationExternalResults.value.document = null;
  }

  state.form.document.isValid = false;
  state.form.document.isLoading = false;

  if (authStore.formErrors.register?.document) {
    authStore.formErrors.register.document = "";
  }
};

const resetDocumentValidationState = () => {
  removeUserDocument();

  if (v$FormValidation.value) {
    v$FormValidation.value.$reset();
  }
};

const cleanExternalResults = (input: string) => {
  // Check if the input field exists in IdentityValidation
  if (v$FormValidation.value[input]) {
    if (v$FormValidationExternalResults.value && v$FormValidationExternalResults.value[input]) {
      v$FormValidationExternalResults.value[input] = null;
      v$FormValidation.value[input].$reset();
    }
  }
};

const isSubmitButtonDisabled = computed(() => {
  return v$FormValidation.value.$invalid || !state.form.document.isValid || state.form.isLoading && (useRuntimeConfig().public.CAPTCHA_ENABLED && !captchaToken.value);
});

// Watche's form errors and bring the user to proper step that have the error
watch(authStore.formErrors.register, () => {
  v$FormValidationExternalResults.value = authStore.formErrors.register;
});

const fillForm = () => {
  // Step 1: Identity
  authStore.form.register.document = "11328969673"; // Example CPF
  authStore.form.register.email = "test@example.com";
  authStore.form.register.phone_code = "+55";
  authStore.form.register.phone = "11999999999";

  // Step 3: Authentication
  authStore.form.register.password = "password123";

  // Check terms and conditions (if applicable)
  authStore.form.register.termsAccepted = true;
};

const clearForm = () => {
  // Step 1: Identity
  authStore.form.register.document = ""; // Example CPF
  authStore.form.register.email = "";
  authStore.form.register.phone_code = "";
  authStore.form.register.phone = "";
  authStore.form.register.password = "";

  // Check terms and conditions (if applicable)
  authStore.form.register.termsAccepted = false;
};

const setTestValuesInExternalResults = () => {
  // Initialize and set test values for IdentityValidationExternalResults
  if (!v$FormValidationExternalResults.value) {
    v$FormValidationExternalResults.value = {};
  }
  for (const key in authStore.form.register) {
    if ((key !== 'termsAccepted' && key !== 'referer') && authStore.form.register.hasOwnProperty(key)) {
      v$FormValidationExternalResults.value[key] = "Test Error for " + key;
    }
  }
};
</script>

<template>
  <div class="flex select-none flex-row">
    <div class="flex w-full flex-col items-center gap-y-6">

      <!-- Logo -->
      <div class="flex py-1 items-center justify-center">
        <BaseLogo class="max-w-24" />
      </div>

      <AuthCouponInfo />

      <!-- Form -->
      <form @submit.prevent class="flex w-full flex-col">

        <div class="flex flex-col gap-y-3">

          <!-- CPF -->
          <BaseInput :id="'legitimuz-hydrate-cpf'" :disabled="state.form.document.isValid" type="numeric-text"
                     name="document" placeholder="CPF" @input.self="handleUserDocumentValidation"
                     @focusin="cleanExternalResults('document')" v-model="authStore.form.register.document"
                     mask="###.###.###-##" class="relative"
                     :error="v$FormValidation.document.$errors[0]?.$message as string">
            <template #icon>
              <BaseButton v-if="!state.form.document.isValid"
                          :disabled="state.form.document.isValid || state.form.document.isLoading"
                          variant="primary" class="h-8 w-8 rounded-lg" @click="authStore.validateDocument()"
                          icon="fa6-solid:magnifying-glass" :loading="state.form.document.isLoading" />
              <BaseButton v-else class="h-8 w-8 rounded-lg" @click="removeUserDocument()" icon="fa6-solid:trash"
                          :loading="state.form.document.isLoading" />
            </template>
          </BaseInput>

          <!-- Name -->
          <BaseInput
            disabled
            v-if="state.form.document.isValid && !authStore.formErrors.register?.document && !v$FormValidation.document.$errors.length"
            type="text"
            placeholder="Nome"
            name="username"
            v-model="authStore.form.register.name"
          />

          <!-- Email -->
          <BaseInput
            type="email"
            placeholder="E-mail"
            name="email-address"
            v-model="authStore.form.register.email"
            @focusin="cleanExternalResults('email')"
            @focusout="v$FormValidation.email.$touch()"
            :error="v$FormValidation.email.$errors[0]?.$message as string"
          />

          <!-- Phone -->
          <div class="flex gap-3 w-full">
            <div class="flex relative items-center">
              <div class="absolute flex items-center rounded-full mt-2 ml-4 overflow-hidden justify-center">
                <Icon name="flag:br-1x1" />
              </div>
              <!-- Tel country code -->
              <BaseInput
                type="numeric-text"
                name="phone-code"
                :disabled="true"
                model-value="55"
                mask="+##"
                placeholder="Código"
                input-class="max-w-24 pl-9"
              />
            </div>

            <!-- Telefone -->
            <BaseInput
              type="numeric-text"
              name="phone-number"
              v-model="authStore.form.register.phone"
              @focusin="cleanExternalResults('phone')"
              @input="authStore.form.register.phone.length > 11 && v$FormValidation.phone.$touch()"
              mask="(##) #####-####"
              placeholder="Telefone com DDD"
              class="flex-1"
              input-class="flex-1"
              :error="v$FormValidation.phone.$errors[0]?.$message as string"
            >
            </BaseInput>
          </div>
          <!-- Password -->
          <div class="flex flex-col gap-y-3">
          <div class="relative"> 
             <BaseInput
              type="password"
              placeholder="Senha"
              name="password"
              @focusin="() => { cleanExternalResults('password'); handlePasswordFocus(); }"
              @focusout="() => { v$FormValidation.password.$touch(); handlePasswordBlur(); }"
              v-model="authStore.form.register.password"
              :error="v$FormValidation.password.$errors.map(e => e.$message as string)"
            />
            <RulesModal
            :password-value="authStore.form.register.password"
            :password-validation="v$FormValidation.password"
            :show="showPasswordRules"  
            @close="handlePasswordRulesClose"
             />
        
          </div>

          </div>
          


        </div>
        <!-- Termos e Condições -->
        <div class="flex items-center justify-center flex-col gap-1 mt-6 text-xss">
          <label class="flex gap-2 items-center cursor-pointer select-none">
            <BaseInputCheckbox v-model="authStore.form.register.termsAccepted" />

            <p class=" text-xs">
              Ao selecionar, concordo com todos os
              <nuxt-link
                to="/terms"
                target="_blank"
                class="text-brand-primary"
                @click.stop
              >
                termos e condições
              </nuxt-link>
            </p>
          </label>

          <small
            class="text-red-500 text-xss"
            v-if="!authStore.form.register.termsAccepted && v$FormValidation.termsAccepted.$errors[0]?.$message"
          >
            Você deve ler e aceitar os termos e condições
          </small>
        </div>

        <BaseInput type="hidden" name="referrer_id" v-model="authStore.form.register.referer" />

        <div class="flex justify-between mt-5 w-full gap-4">
          <BaseButton class="w-full" :id="'legitimuz-action-send-analisys'" variant="primary"
                      @click="submit()" :disabled="isSubmitButtonDisabled"
                      :loading="state.form.isLoading">
            <div class="flex items-center justify-center gap-2">
              <p>Concluir cadastro</p>
            </div>
          </BaseButton>
        </div>

        <AuthRegisterCaptcha v-model="captchaToken" />

        <p @click="authStore.modalOpen('login')"
           class="cursor-pointer mt-4 text-center text-xs font-bold text-bzMenuText">
          Já tem uma conta?
          <span class="text-brand-primary hover:text-brighten-brand-primary">Entre agora!</span>
        </p>

      </form>

<!--      <BaseButton @click="fillForm()">Fill</BaseButton>-->
<!--      <BaseButton @click="clearForm()">Clear</BaseButton>-->
<!--      <BaseButton @click="setTestValuesInExternalResults()">Set External errors</BaseButton>-->
    </div>
  </div>
</template>